import { render, staticRenderFns } from "./dialog-tagversionoptional.vue?vue&type=template&id=6d6a8506&"
import script from "./dialog-tagversionoptional.vue?vue&type=script&lang=js&"
export * from "./dialog-tagversionoptional.vue?vue&type=script&lang=js&"
import style0 from "./dialog-tagversionoptional.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports